import { render, staticRenderFns } from "./LEDForm.vue?vue&type=template&id=173feb96&scoped=true&"
import script from "./LEDForm.vue?vue&type=script&lang=js&"
export * from "./LEDForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173feb96",
  null
  
)

export default component.exports